export enum EFillApplicationStickyButtonType {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export interface IMasterButtonProps {
  currentButtonType: EFillApplicationStickyButtonType;
}
